import {getAdConfig} from './getAdConfig';
import {AMAZON_PUB_ID, ADSERVER} from "./constants";

if (evite.features.isEnabled('enable_amazon_apstag', false)) {
  // load the apstag.js library
  !(function (a9, a, p, s, t, A, g) {
    if (a[a9]) return;
    function q(c, r) {
      a[a9]._Q.push([c, r]);
    }
    a[a9] = {
      init: function () {
        q('i', arguments);
      },
      fetchBids: function () {
        q('f', arguments);
      },
      setDisplayBids: function () {},
      targetingKeys: function () {
        return [];
      },
      _Q: [],
    };
    A = p.createElement(s);
    A.async = !0;
    A.src = t;
    g = p.getElementsByTagName(s)[0];
    g.parentNode.insertBefore(A, g);
  })('apstag', window, document, 'script', '//c.amazon-adsystem.com/aax2/apstag.js');
}

export const initializeAmazonBids = ({index, isLargishAndUp, configKey}) =>
  new Promise((resolve) => {
    const adConfig = getAdConfig({index, isLargishAndUp, configKey});

    if (!window.apstag) return resolve();

    window.apstag.init({pubID: AMAZON_PUB_ID, adServer: ADSERVER,});
    window.apstag.fetchBids({
        slots: [{
            slotID: adConfig.adPlacementName,
            slotName: adConfig.adSlotUrl,
            sizes: adConfig.dimensions,
          }],
        timeout: 2e3,
      },
      resolve
    );
  });

export const refreshAmazonBids = async (adConfig) => {
  if (window.apstag) {
    await new Promise((resolve) => {
      window.apstag.fetchBids({
          slots: [{
              slotID: adConfig.adPlacementName,
              slotName: adConfig.adSlotUrl,
              sizes: adConfig.dimensions,
            }],
          timeout: 2e3,
        },
        resolve
      );
    });

    window.apstag.setDisplayBids();
  }
};
